import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import _ from 'underscore';

import { Breadcrumb } from '@fluentui/react';

const maxDisplayedItems = 5;

export const FolderPathBreadcrumb = ({
  visibleForRootFolder,
  folderPath,
  onItemClick,
}) => {
  const breadcrumbItems = useMemo(() => {
    const items = _.map(folderPath, item => ({
      key: item.folderId,
      text: item.folderName,
      onClick: () => { onItemClick(item); },
    }));

    return items;
  }, [folderPath, onItemClick]);

  return (
    folderPath && (visibleForRootFolder || folderPath.length > 1) ?
      <Breadcrumb
        items={breadcrumbItems}
        styles={{
          itemLink: {
            fontSize: 14, maxWidth: 160, padding: 0, margin: '0 8px',
          },
        }}
        maxDisplayedItems={maxDisplayedItems}
        className="folder-path-breadcrumb"
        overflowIndex={Math.min(breadcrumbItems.length - 1, 1)}
      /> : null
  );
};

FolderPathBreadcrumb.propTypes = {
  visibleForRootFolder: PropTypes.bool,
  folderPath: PropTypes.arrayOf(PropTypes.shape({
    folderId: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    folderName: PropTypes.string,
  })).isRequired,
  onItemClick: PropTypes.func.isRequired,
};

FolderPathBreadcrumb.defaultProps = {
  visibleForRootFolder: false,
};
